// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"598":"videojs-6b44a98f","997":"slick"}[chunkId] + "." + {"598":"9ae246f8af6d6881ded8","997":"bdf29d186c9988e32953"}[chunkId] + ".css";
};